// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import surveyResponseEntity from './entities/survey-response.json';
import surveyResponseMenu from '../pages/survey-response/menu.json';
import surveyResponseFullForm from '../pages/survey-response/forms/full.json';
import surveyResponseContextForm from '../pages/survey-response/forms/context.json';
import surveyResponseMiniForm from '../pages/survey-response/forms/mini.json';
import surveyResponseLookupForm from '../pages/survey-response/forms/lookup.json';
import surveyResponseTableView from '../pages/survey-response/views/table.json';
import surveyResponseCardsView from '../pages/survey-response/views/cards.json';
import surveyResponseDashboardView from '../pages/survey-response/views/dashboard.json';

/** Тип запису «Відповідь респондента» зі сторінками пакета: меню, форми та подання з pages/survey-response/. */
export const surveyResponseDefinition: IRecordTypeDefinition = {
  ...surveyResponseEntity,
  views: assembleViewSet({
      table: surveyResponseTableView,
      cards: surveyResponseCardsView,
      dashboard: surveyResponseDashboardView,
  }),
  form: surveyResponseFullForm,
  forms: { full: surveyResponseFullForm, context: surveyResponseContextForm, mini: surveyResponseMiniForm, lookup: surveyResponseLookupForm },
  menu: surveyResponseMenu,
} as IRecordTypeDefinition;
